import { SingleSelectChip } from '@/common/components/shared/single-select-chip/SingleSelectChip';
import { ReplacementValue } from '@/common/graphql';
import { ReplacementValueLabels } from '@/common/types';
import { ObjectUtils, StringUtils } from '@/common/utils';

interface ReplacementValueSelectChipProps {
  value: ReplacementValue | null;
  onChange: (value: ReplacementValue | null) => void;
  disabled?: boolean;
  error?: string;
}

const sortOrder = [ReplacementValue.Extreme, ReplacementValue.High, ReplacementValue.Medium, ReplacementValue.Low];

const options = ObjectUtils.arrayFromEnumValues<ReplacementValue>(ReplacementValue).sort(
  (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b),
);

export const ReplacementValueSelectChip = (props: ReplacementValueSelectChipProps) => (
  <SingleSelectChip
    {...props}
    items={options}
    label={option => ReplacementValueLabels[option]}
    reactKey={option => option}
    title={option => StringUtils.capitalize(option)}
  />
);
